import { FC } from 'react';

type Props = {
    className?: string;
};

const RepairIconDuotone: FC<Props> = ({ className }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            fill="none"
        >
            <path
                opacity="0.4"
                d="M4.16797 6.24984L6.2513 4.1665L3.7513 2.9165L2.91797 3.74984L4.16797 6.24984Z"
                fill="#2B2B2B"
            />
            <path
                opacity="0.4"
                d="M14.5021 16.7532L9.83203 12.0831L12.0846 9.83057L16.7547 14.5006C17.1945 14.9405 17.1945 15.6536 16.7547 16.0935L16.0949 16.7532C15.655 17.1931 14.9419 17.1931 14.5021 16.7532Z"
                fill="#2B2B2B"
            />
            <path d="M9.16667 9.16667L5 5" stroke="#2B2B2B" strokeWidth="1.25" />
            <path
                d="M4.16797 6.24984L6.2513 4.1665L3.7513 2.9165L2.91797 3.74984L4.16797 6.24984Z"
                stroke="#2B2B2B"
                strokeWidth="1.25"
                strokeLinejoin="round"
            />
            <path
                d="M16.6457 7.47906C17.4882 6.63659 17.7076 5.40697 17.3037 4.3629L16.1187 5.5479H14.4521V3.88123L15.6371 2.69623C14.593 2.29246 13.3634 2.5118 12.5209 3.35427C11.6782 4.19706 11.4589 5.42728 11.8633 6.47161L6.47161 11.8633C5.42729 11.4589 4.19706 11.6782 3.35427 12.5209C2.5118 13.3634 2.29246 14.593 2.69623 15.6371L3.88123 14.4521H5.5479V16.1187L4.3629 17.3037C5.40697 17.7076 6.63659 17.4882 7.47906 16.6457C8.32121 15.8036 8.54075 14.5746 8.13756 13.5307L13.5307 8.13756C14.5746 8.54075 15.8036 8.32121 16.6457 7.47906Z"
                stroke="#2B2B2B"
                strokeWidth="1.25"
                strokeLinejoin="round"
            />
            <path
                d="M9.83203 12.0831L14.502 16.7532C14.9419 17.1931 15.655 17.1931 16.0949 16.7532L16.7546 16.0935C17.1945 15.6536 17.1945 14.9405 16.7546 14.5006L12.0846 9.83057"
                stroke="#2B2B2B"
                strokeWidth="1.25"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default RepairIconDuotone;
